import { render, staticRenderFns } from "./model-popularStores.vue?vue&type=template&id=bb628374&scoped=true&"
import script from "./model-popularStores.vue?vue&type=script&lang=js&"
export * from "./model-popularStores.vue?vue&type=script&lang=js&"
import style0 from "./model-popularStores.vue?vue&type=style&index=0&id=bb628374&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb628374",
  null
  
)

export default component.exports